<template>
  <div class="StoryWidget">
    <div class="bg flexTop">
      <div class="image">
        <img :src="img" :alt="title" />
      </div>
      <a :href="storyHref" class="text flexTop" target="_blank">
        <div class="authors">
          {{authorsText}}
        </div>
        <div class="title" v-html="title">
          {{title}}
        </div>
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StoryWidget',
    data(){
      return {
      }
    },
    components:{
    },
    props: {
      title: {
        type: String,
        default: ""
      },
      img: {
        type: String,
        default: ""
      },
      authors: {
        type: Array,
        default: ()=>{}
      },
      storyHref: {
        type: String,
        default: ""
      },
      bgImageStyle: {
        type: Object,
        default: ()=>{
          return {
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }
        }
      }
    },
    computed: {
      widgetStyle(){
        return {
        }
      },
      authorsText(){
        return this.authors.join(", ")
      }
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/_fonts';

  .bg{
    position: relative;
  }
  .image{

    img{
      width: 100%;
      display: block;
    }
  }

  .flexCenter{
    display: flex;
    justify-content: center;
    align-content: stretch;
    flex-direction: column;
  }

  .flexTop{
    display: flex;
    justify-content: flex-start;
    align-content: stretch;
    flex-direction: column;
  }

  .authors{
    .FD;
    font-size: 14px;
    line-height: 17px;
    text-transform: uppercase;
    margin-bottom: 20px;
    letter-spacing: 1px;
  }

  .text{
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 53px 30px; 
    color: #fff;
    text-decoration: none;
    /*background: radial-gradient(ellipse at center, rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 100%);*/
    background: linear-gradient(to bottom, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0) 100%);
    *{
      color: #fff;
    }
    .title{
      .FD;
      font-size: 36px;
      line-height: 42px;
    }
  }

</style>
